import { __awaiter, __generator } from "tslib";
import { getFileNativeUriScheme } from '@office-start/file-utility';
import { launchUrl } from '@office-start/launcher-service';
export function createOpenInNativeAppAction(item) {
    var _this = this;
    if (!item.fileType || item.isEmailAttachment || !item.canonicalUrl) {
        return undefined;
    }
    var nativeUriScheme = getFileNativeUriScheme(item.fileType);
    if (!nativeUriScheme) {
        return undefined;
    }
    var canonicalUrl = item.canonicalUrl;
    var queryIndex = canonicalUrl.lastIndexOf('?');
    if (queryIndex > 0) {
        // Strip any query params off the canonical url, as it is not needed for launching desktop apps
        canonicalUrl = canonicalUrl.substring(0, queryIndex);
    }
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var linkTarget, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    linkTarget = '_self';
                    action = 'OpenInApp';
                    return [4 /*yield*/, launchUrl("".concat(nativeUriScheme).concat(canonicalUrl), {
                            action: action,
                            linkTarget: linkTarget,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=createOpenInNativeAppAction.js.map